export default __webpack_public_path__ + "static/media/bpr.c9183125.JPG";